module.exports = __webpack_public_path__ + "static/media/screenshot_2.758f1d3a.avif";